import Leads from '@/pages/Leads';

export default function MobileLeadsScreen() {
  return <Leads />;
}

